import type {Auth} from 'src/typings';
import {states} from 'shared/constants';
import type {AuthenticationSystemView, LoginView} from 'shared/login/kp-login/types';
import {getContext, hasContext, setContext} from 'svelte';
import type {Readable} from 'svelte/store';
import {writable} from 'svelte/store';
import type {LoginFormState} from 'shared/login/types';

const LOGIN_SYSTEMS_CONTEXT_KEY = 'login-systems-context-key';

export interface LoginSystemsContext {
    loginView: LoginView;
    authSystemView: AuthenticationSystemView;
    onLoginSuccess: (auth: Auth) => void;
    onLoginCancel: () => void;
}

export function getLoginSystemsContext(): LoginSystemsContext {
    if (!hasContext(LOGIN_SYSTEMS_CONTEXT_KEY)) {
        throw new Error('LoginSystemsContext is required!');
    }
    return getContext(LOGIN_SYSTEMS_CONTEXT_KEY);
}

export function setLoginSystemsContext(loginSystemsContext: LoginSystemsContext): LoginSystemsContext {
    setContext(LOGIN_SYSTEMS_CONTEXT_KEY, loginSystemsContext);
    return loginSystemsContext;
}


const LOGIN_FORM_CONTEXT_KEY = 'login-form-context-key';

export interface LoginFormContext {
    state$: Readable<LoginFormState>;
    startProcessing: () => void;
    stopProcessing: () => void;
    setError: (errorMessage: string) => void;
    clearError: () => void;
}

export function getLoginFormContext(): LoginFormContext {
    if (!hasContext(LOGIN_FORM_CONTEXT_KEY)) {
        throw new Error('LoginFormContext is required!');
    }
    return getContext(LOGIN_FORM_CONTEXT_KEY);
}

export function setLoginFormContext(): LoginFormContext {
    const initialState: LoginFormState = {
        status: states.NORMAL,
        errorMessage: null
    };
    const state$ = writable(initialState);
    const loginFormContext: LoginFormContext = {
        state$,
        startProcessing: () => state$.update((state) => ({...state, status: states.PROCESSING})),
        stopProcessing: () => state$.update((state) => ({...state, status: states.NORMAL})),
        setError: (errorMessage: string) => state$.set({errorMessage, status: states.ERRORED}),
        clearError: () => state$.set({errorMessage: null, status: states.NORMAL}),

    }
    setContext(LOGIN_FORM_CONTEXT_KEY, loginFormContext);
    return loginFormContext;
}

